import React from "react";
import profile from "../../Assets/Images/undraw_profile.svg";

const Feed = ({ feed }) => {
  return (
    <div className="container-fluid top-container">
      <div className="row">
        <div className="col-md-12 post mb-5">
          <div className="card h-100">
            <div className="card-body">
              <div className="row">
                <div className="col-md-1"></div>
                <div className="col-md-4">
                  <p className="pro-title">Mentor</p>
                  <br />
                  <div className="profile-card mt-3">
                    <div className="card-body p-3">
                      <div className="d-flex">
                        <img
                          className="img-profile rounded-circle"
                          src={feed?.mentor_pic_url || profile}
                          alt="mentor-profile"
                        />
                        <p className="mt-2 ml-2 mb-0">{feed?.mentor_name}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <p className="pro-title">Mentee </p>
                  <br />
                  <div className="profile-card mt-3">
                    <div className="card-body p-3">
                      <div className="d-flex">
                        <img
                          className="img-profile rounded-circle"
                          src={feed?.mentee_pic_url || profile}
                          alt="mentee-profile"
                        />
                        <p className="mt-2 ml-2 mb-0">{feed?.mentee_name}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-5">
                <div className="col-md-1"></div>
                <div className="col-md-9">
                  <table className="table">
                    <tr>
                      <td className="border-top-0 view-tab">Title</td>
                      <td className="border-top-0 view-tab">:</td>
                      <td className="border-top-0 view-tab">{feed?.subject}</td>
                    </tr>
                    <tr>
                      <td className="border-top-0 view-tab">
                        Session Feedback
                      </td>
                      <td className="border-top-0 view-tab">:</td>
                      <td className="border-top-0 view-tab">
                        {feed?.sessionFeedback}
                      </td>
                    </tr>

                    {feed?.sessionIssue && feed?.sessionIssue.length > 0 && (
                      <tr>
                        <td className="border-top-0 view-tab">
                          Encountered Issues
                        </td>
                        <td className="border-top-0 view-tab">:</td>
                        <td className="border-top-0 view-tab">
                          {feed?.sessionIssue.join(",")}
                        </td>
                      </tr>
                    )}
                    <tr>
                      <td className="border-top-0 view-tab">
                        {" "}
                        How likely are you to use our application again?
                      </td>
                      <td className="border-top-0 view-tab">:</td>
                      <td className="border-top-0 view-tab">
                        {feed?.useApplication || "-"}
                      </td>
                    </tr>
                    {feed?.factors && feed?.factors.length > 0 && (
                      <tr>
                        <td className="border-top-0 view-tab">
                          Encountered Issues
                        </td>
                        <td className="border-top-0 view-tab">:</td>
                        <td className="border-top-0 view-tab">
                          {feed?.factors.join(",")}
                        </td>
                      </tr>
                    )}
                    <tr>
                      <td className="border-top-0 view-tab">
                        {" "}
                        App Recommendation
                      </td>
                      <td className="border-top-0 view-tab">:</td>
                      <td className="border-top-0 view-tab">
                        {feed?.appRecommendation || "-"}
                      </td>
                    </tr>
                    {feed?.reasons && feed?.reason.length > 0 && (
                      <tr>
                        <td className="border-top-0 view-tab">
                          Encountered Issues
                        </td>
                        <td className="border-top-0 view-tab">:</td>
                        <td className="border-top-0 view-tab">
                          {feed?.reason.join(",")}
                        </td>
                      </tr>
                    )}
                    <tr>
                      <td className="border-top-0 view-tab">Description</td>
                      <td className="border-top-0 view-tab">:</td>
                      <td className="border-top-0 view-tab">
                        {feed?.description || "-"}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Feed;
